module.exports = __webpack_public_path__ + "img/character-male.c9d9c4b4.jpg";